export default __webpack_public_path__ + "static/media/Disposal-green.77a6bc1e.svg";